import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/access_/')({
	beforeLoad: () => {
		throw redirect({
			to: '/access/overview',
		});
	},
});
